import React, { useState, useEffect, CSSProperties } from 'react';
import Tooltip from '../../../muiComponents/Tooltip';

interface FlagProps {
    text?: string;
    code: string;
    style?: CSSProperties;
}

const Flag = ({ code, text, style }: FlagProps) => {
    const codeLowerCase = code?.toLowerCase();
    const validSrc = `/flags/${code}.svg`;
    const fallbackSrc = '/flags/default-flag.svg';

    const [src, setSrc] = useState(validSrc);

    useEffect(() => {
        setSrc(validSrc);
    }, [validSrc]);

    return (
        <Tooltip title={text || codeLowerCase}>
            <img
                loading='lazy'
                key={src}
                src={src}
                onError={() => {
                    if (src !== fallbackSrc) {
                        setSrc(fallbackSrc);
                    }
                }}
                alt={`Flag of ${text || codeLowerCase}`}
                style={{
                    width: '21px',
                    height: '16px',
                    objectFit: 'cover',
                    ...style,
                }}
            />
        </Tooltip>
    );
};

export default Flag;
